// tslint:disable
export var AccountPhoneContactInformationType;
(function (AccountPhoneContactInformationType) {
    // UNKN
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["UNKN"] = 0] = "UNKN";
    // PHONE
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["PHONE"] = 1] = "PHONE";
    // MOBILE
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["MOBILE"] = 2] = "MOBILE";
    // FAX
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["FAX"] = 3] = "FAX";
    // WEB
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["WEB"] = 4] = "WEB";
    // E-MAIL
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["EMAIL"] = 5] = "EMAIL";
    // DNC
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["DNC"] = 6] = "DNC";
    // FACEBOOK
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["FACEBOOK"] = 7] = "FACEBOOK";
    // TWITTER
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["TWITTER"] = 8] = "TWITTER";
    // LINKEDIN
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["LINKEDIN"] = 9] = "LINKEDIN";
    // GOOGLEPLUS
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    // YOUTUBE
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["YOUTUBE"] = 11] = "YOUTUBE";
    // Text
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["Text"] = 12] = "Text";
    // Mail
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["Mail"] = 13] = "Mail";
    // MANGO
    AccountPhoneContactInformationType[AccountPhoneContactInformationType["MANGO"] = 14] = "MANGO";
})(AccountPhoneContactInformationType || (AccountPhoneContactInformationType = {}));
AccountPhoneContactInformationType['TEXT'] = 12;
AccountPhoneContactInformationType['MAIL'] = 13;
//# sourceMappingURL=AccountPhoneContactInformationType.js.map